import "can/model/";


export default can.Model.extend({
    findAll() {
        "use strict";

        return can.ajax({
            url: "/api/v2/myAccount",
            type: "GET",
            dataType: "json"
        });
    },

    parseModels(data) {
        return [data];
    }
}, {});
